import { useState, useEffect } from 'react';
import imageConfig from '../config/imageConfig.json';

// Image import map - we still need to import the actual files
const imageImports = {
  // Profile images
  '../assets/profile.jpg': require('../assets/profile.jpg'),
  
  // Logo images
  '../assets/Alacat_01_Artboard_1.png': require('../assets/Alacat_01_Artboard_1.png'),
  '../assets/Bloomberg_logo.jpeg': require('../assets/Bloomberg_logo.jpeg'),
  '../assets/box_logo.jpeg': require('../assets/box_logo.jpeg'),
  '../assets/returnlogic_logo.jpeg': require('../assets/returnlogic_logo.jpeg'),
  '../assets/dickinson_college_logo.jpeg': require('../assets/dickinson_college_logo.jpeg'),
  '../assets/fashion_institute_of_technology_logo.jpeg': require('../assets/fashion_institute_of_technology_logo.jpeg'),

  // Recipe images
  '../assets/focaccia.jpg': require('../assets/focaccia.jpg'),
  '../assets/cozonac.jpg': require('../assets/cozonac.jpg'),
  '../assets/vanilla_cake.jpg': require('../assets/vanilla_cake.jpg'),
  '../assets/honey_lavender_cake.jpg': require('../assets/honey_lavender_cake.jpg'),
  '../assets/giusy_biscotti.jpg': require('../assets/giusy_biscotti.jpg'),
  '../assets/recipe_image_7.jpg': require('../assets/recipe_image_7.jpg'),
  '../assets/recipe_image_8.jpg': require('../assets/recipe_image_8.jpg'),
  '../assets/recipe_image_9.jpg': require('../assets/recipe_image_9.jpg'),
  '../assets/recipe_image_10.jpg': require('../assets/recipe_image_10.jpg'),
  '../assets/recipe_image_11.jpg': require('../assets/recipe_image_11.jpg'),
  '../assets/figs_arugula_feta_focaccia.jpg': require('../assets/figs_arugula_feta_focaccia.jpg'),
  '../assets/focaccias.jpg': require('../assets/focaccias.jpg'),
  '../assets/biscotti_log.jpg': require('../assets/biscotti_log.jpg')
};

const useImages = () => {
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    // Process the config and resolve actual image imports
    const processedImages = {
      recipeImages: {},
      profileImages: {},
      logoImages: {}
    };

    // Process recipe images
    Object.entries(imageConfig.recipeImages).forEach(([recipeKey, images]) => {
      processedImages.recipeImages[recipeKey] = images.map(img => ({
        ...img,
        src: imageImports[img.src] || img.src
      }));
    });

    // Process profile images
    Object.entries(imageConfig.profileImages).forEach(([key, image]) => {
      processedImages.profileImages[key] = {
        ...image,
        src: imageImports[image.src] || image.src
      };
    });

    // Process logo images
    Object.entries(imageConfig.logoImages).forEach(([key, image]) => {
      processedImages.logoImages[key] = {
        ...image,
        src: imageImports[image.src] || image.src
      };
    });

    setLoadedImages(processedImages);
  }, []);

  // Helper functions
  const getRecipeImages = (recipeName) => {
    return loadedImages.recipeImages?.[recipeName] || [];
  };

  const getProfileImage = (imageName = 'main') => {
    return loadedImages.profileImages?.[imageName];
  };

  const getLogoImage = (logoName) => {
    return loadedImages.logoImages?.[logoName];
  };

  const getCompanyLogo = (companyName) => {
    const logoMap = {
      'Bloomberg LP': 'bloomberg',
      'Box, Inc.': 'box',
      'Return Logic, Inc.': 'returnlogic',
      'Dickinson College': 'dickinson',
      'Fashion Institute of Technology': 'fit'
    };
    
    const logoKey = logoMap[companyName];
    return logoKey ? getLogoImage(logoKey) : null;
  };

  return {
    images: loadedImages,
    getRecipeImages,
    getProfileImage,
    getLogoImage,
    getCompanyLogo,
    isLoaded: Object.keys(loadedImages).length > 0
  };
};

export default useImages;